import React from "react";
import styled from "styled-components";

type TFadeInProps = {
  children: React.ReactNode;
  isVisible: boolean;
};

const FadeWrapper = styled.div<{ $isVisible: boolean }>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: opacity 0.75s ease-in-out;
`;

export default function FadeIn({ children, isVisible }: TFadeInProps) {
  return <FadeWrapper $isVisible={isVisible}>{children}</FadeWrapper>;
}
